module.exports = __webpack_public_path__ + "static/media/play-store.ce315700.svg";